import { FormAccessDTO } from "../ClientDTO";

export class DocumentTypeDTO implements IDocumentTypeDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;
  sortOrder?: string | null;
  allowEdit?: boolean | null;

  constructor(data?: IDocumentTypeDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
          this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;      
          this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;        
          this.allowEdit = _data["allowEdit"] !== undefined ? _data["allowEdit"] : <any>null;

      }
  }

  static fromJS(data: any): DocumentTypeDTO {
      data = typeof data === 'object' ? data : {};
      let result = new DocumentTypeDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      data["tag"] = this.tag !== undefined ? this.tag : <any>null;
      data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
      data["allowEdit"] = this.allowEdit !== undefined ? this.allowEdit : <any>null;
      return data;
  }
}

export interface IDocumentTypeDTO {
  id?: number;
  name?: string | null;
  tag?: string | null;
  sortOrder?: string | null;
  allowEdit?: boolean | null;
}export interface IByteArrayStringStringTuple {
  item1?: string | null;
  item2?: string | null;
  item3?: string | null;
}

export class DocumentDTO implements IDocumentDTO {
    id?: number;
    writeRevision?: boolean | undefined;
    identity?: string | undefined;
    name?: string | undefined;
    caseId?: number | undefined;
    parentCaseId?: number | undefined;
    caseTypeId?: number | undefined;
    date?: Date | undefined;
    documentStateId?: number | undefined;
    documentTypeId?: number | undefined;
    documentCommunicationTypeId?: number | undefined;
    documentIssuerId?: number | undefined;
    issuerNumber?: string | undefined;
    issuerDate?: Date | undefined;
    documentModeId?: number | undefined;
    currentFile?: FileDTO;

    constructor(data?: IDocumentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.writeRevision = _data["writeRevision"];
            this.identity = _data["identity"];
            this.name = _data["name"];
            this.caseId = _data["caseId"];
            this.parentCaseId = _data["parentCaseId"];
            this.caseTypeId = _data["caseTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.documentStateId = _data["documentStateId"];
            this.documentTypeId = _data["documentTypeId"];
            this.documentCommunicationTypeId = _data["documentCommunicationTypeId"];
            this.documentIssuerId = _data["documentIssuerId"];
            this.issuerNumber = _data["issuerNumber"];
            this.issuerDate = _data["issuerDate"] ? new Date(_data["issuerDate"].toString()) : <any>undefined;
            this.documentModeId = _data["documentModeId"];
            this.currentFile = _data["currentFile"] ? FileDTO.fromJS(_data["currentFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["writeRevision"] = this.writeRevision;
        data["identity"] = this.identity;
        data["name"] = this.name;
        data["caseId"] = this.caseId;
        data["parentCaseId"] = this.parentCaseId;
        data["caseTypeId"] = this.caseTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["documentStateId"] = this.documentStateId;
        data["documentTypeId"] = this.documentTypeId;
        data["documentCommunicationTypeId"] = this.documentCommunicationTypeId;
        data["documentIssuerId"] = this.documentIssuerId;
        data["issuerNumber"] = this.issuerNumber;
        data["issuerDate"] = this.issuerDate ? this.issuerDate.toISOString() : <any>undefined;
        data["documentModeId"] = this.documentModeId;
        data["currentFile"] = this.currentFile ? this.currentFile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDocumentDTO {
    id?: number;
    writeRevision?: boolean | undefined;
    identity?: string | undefined;
    name?: string | undefined;
    caseId?: number | undefined;
    parentCaseId?: number | undefined;
    caseTypeId?: number | undefined;
    date?: Date | undefined;
    documentStateId?: number | undefined;
    documentTypeId?: number | undefined;
    documentCommunicationTypeId?: number | undefined;
    documentIssuerId?: number | undefined;
    issuerNumber?: string | undefined;
    issuerDate?: Date | undefined;
    documentModeId?: number | undefined;
    currentFile?: FileDTO;
}
export class FileDTO implements IFileDTO {
  id?: number;
  writeRevision?: boolean | null;
  identity?: string;
  fileName?: string | null;
  documentUploadTypeId?: number;

  constructor(data?: IFileDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
          this.identity = _data["identity"] !== undefined ? _data["identity"] : <any>null;
          this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
          this.documentUploadTypeId = _data["documentUploadTypeId"] !== undefined ? _data["documentUploadTypeId"] : <any>null;
      }
  }

  static fromJS(data: any): FileDTO {
      data = typeof data === 'object' ? data : {};
      let result = new FileDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
      data["identity"] = this.identity !== undefined ? this.identity : <any>null;
      data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
      data["documentUploadTypeId"] = this.documentUploadTypeId !== undefined ? this.documentUploadTypeId : <any>null;
      return data;
  }
}

export class DocumentsListResponse implements IDocumentsListResponse {
    id?: number;
    identity?: string | null;
    name?: string | null;
    date?: Date;
    documentNumber?: number | null;
    documentType?: string | null;
    state?: string | null;
    documentMode?: string | null;

    constructor(data?: IDocumentsListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.identity = _data["identity"] !== undefined ? _data["identity"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.documentMode = _data["documentMode"] !== undefined ? _data["documentMode"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["identity"] = this.identity !== undefined ? this.identity : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["documentMode"] = this.documentMode !== undefined ? this.documentMode : <any>null;
        return data;
    }
}

export interface IDocumentsListResponse {
    id?: number;
    identity?: string | null;
    name?: string | null;
    date?: Date;
    documentNumber?: number | null;
    documentType?: string | null;
    state?: string | null;
    documentMode?: string | null;
}

export interface IFileDTO {
  id?: number;
  writeRevision?: boolean | null;
  identity?: string;
  fileName?: string | null;
  documentUploadTypeId?: number;
}

export class ByteArrayStringStringTuple implements IByteArrayStringStringTuple {
  item1?: string | null;
  item2?: string | null;
  item3?: string | null;

  constructor(data?: IByteArrayStringStringTuple) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.item1 = _data["item1"] !== undefined ? _data["item1"] : <any>null;
          this.item2 = _data["item2"] !== undefined ? _data["item2"] : <any>null;
          this.item3 = _data["item3"] !== undefined ? _data["item3"] : <any>null;
      }
  }

  static fromJS(data: any): ByteArrayStringStringTuple {
      data = typeof data === 'object' ? data : {};
      let result = new ByteArrayStringStringTuple();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["item1"] = this.item1 !== undefined ? this.item1 : <any>null;
      data["item2"] = this.item2 !== undefined ? this.item2 : <any>null;
      data["item3"] = this.item3 !== undefined ? this.item3 : <any>null;
      return data;
  }
}